import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import styled from 'styled-components';
import { PermissionsProvider } from '../context/PermissionsContext';
import ErrorBoundary from './ErrorBoundary';
import SubscriptionHighlight from './SubscriptionHighlight';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "SubscriptionHighlightWrapper__StyledDiv",
  componentId: "sc-17sg3m0-0"
})(({
  theme
}) => `
  border-bottom: 1px solid ${theme.color['border-core-default']};
  padding: ${theme.space['600']} ${theme.space['600']} ${theme.space['400']} ${theme.space['600']};
`);
function SubscriptionHighlightWrapper({
  objectId,
  permissions,
  auth,
  closeSidebar
}) {
  return /*#__PURE__*/_jsx(StyledDiv, {
    "data-test-id": "subscription-highlight-card",
    children: /*#__PURE__*/_jsx(ErrorBoundary, {
      identifier: "subscription-highlight-card-error-boundary",
      fallback: /*#__PURE__*/_jsx(ErrorMessage, {}),
      children: /*#__PURE__*/_jsx(PermissionsProvider, {
        values: Object.assign({}, permissions, auth, {
          closeSidebar
        }),
        children: /*#__PURE__*/_jsx(SubscriptionHighlight, {
          objectId: objectId
        })
      })
    })
  });
}
export default SubscriptionHighlightWrapper;